/*
* @Author: your name
* @desc:
*/
import { observable, action, runInAction, toJS } from "mobx";
import { getLabel } from '@weapp/utils';
import { Dialog } from '@weapp/ui';

import * as API from './../../../../../api/pc/tenantInfo';
import { TenantParamsType, TenantApplyParamsType } from './type';
const { message } = Dialog;

export class TeamsJoinStore {

  @observable tenantList: any = [];//组织列表
  @observable currentApplyTenantKey: string = '';//当前正在申请加入的组织
  @observable applyVisible: boolean = false;//显示加入组织申请
  @observable cancelApplyMap = new Map()

  @action
  changeApplyKey = (key: string) => {
    this.currentApplyTenantKey = key;
  }

  @action
  reset = () => {
    this.applyVisible = false;
    this.tenantList = [];
  }

  @action
  queryTenant = (params: TenantParamsType, callback?: () => void) => {
    API.queryTenant(params).then((result: any) => {
      if (result?.data?.msg) {
        message({
          type: "error",
          content: getLabel(result.data.i18nId, result.data.msg),
        });
      } else {
        runInAction(() => {
          this.tenantList = result.data?.tenantList || [];
          const applyTenants = result.data?.applyTenant;
          const cancelApplyMarkArray: string[] = [];
          applyTenants && (applyTenants as Array<any>).length > 0 && applyTenants.forEach((item: any) => {
            // 获取第一个等号前面的值
            const teanntKeyMatch = item.match(/([^=]+)=/);
            let tenantKey = teanntKeyMatch ? teanntKeyMatch[1] : '';
            tenantKey && cancelApplyMarkArray.push(`${tenantKey}=apply`)
            // 获取第二个等号后面的值
            const applyListIdMatch = item.match(/applyListId=(\d+)/);
            const applyListId = applyListIdMatch ? applyListIdMatch[1] : '';
            tenantKey = tenantKey.toLowerCase()
            this.cancelApplyMap.set(tenantKey, applyListId)
          })
          this.tenantList.forEach((it: any) => {
            if (cancelApplyMarkArray && cancelApplyMarkArray.includes(`${(it.tenantKey as string).toLocaleUpperCase()}=apply`)) {
              it.showApply = true;
            }
          });
          callback && callback();
        });
      }
    }).catch((error: any) => {
      console.log(error);
    });
  };
  @action
  sendApply = (params: TenantApplyParamsType, callback?: (result?: any) => void, fail?: ()=> void) => {
    API.sendApply(params).then((result: any) => {
      if (result?.data?.msg) {
        message({
          type: "error",
          content: getLabel(result.data.i18nId, result.data.msg)
        });
        fail?.()
      } else {
        callback && callback(result)
      }
    }).catch((error: any) => {
      console.log(error);
      fail?.()
    });
  };
  @action
  cancleApply = (params: any) => {
    API.cancleApply(params).then((result: any) => {
      if (result?.data?.msg) {
        message({
          type: "error",
          content: getLabel(result.data.i18nId, result.data.msg)
        });
      } else {
        runInAction(() => {
          this.tenantList.forEach((it: any) => {
            if (it.tenantKey === params.tenantKey) {
              it.showApply = false;
            }
          });
          this.tenantList = [...this.tenantList];
        })
      }
    }).catch((error: any) => {
      console.log(error);
    });
  };

  @action
  recoverTenant = (params: any, callback?: Function) => { // 恢复已注销团队时直接调用申请加入接口
    this.sendApply(params, callback as any);
  }
}
const instance = new TeamsJoinStore();

export default instance;
export type TeamsJoinStoreType = Pick<TeamsJoinStore, keyof TeamsJoinStore>;
